import { CMS_API_URL, CMS_API_KEY } from "../config";

export async function getContentList(content_name, content_language) {
  try {
    const response = await fetch(
      `${CMS_API_URL}/${content_name}?populate=*&locale=${content_language}`,
      {
        headers: {
          Authorization: 'Bearer ' + CMS_API_KEY,
        },
      }
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    return await response.json();
  } catch (error) {
    console.error('Fetch error:', error);
    return null;
  }
}
